<template>
    <div class="multi-question-response">
        <div v-for="(question, oIndex) in question.questions"
            :key="oIndex"
            class="answer-holder">
            <span class="question">
                <strong> {{ question.title }}</strong> ({{ question.question }})
            </span>
            <div
                :class="['multi-partial-response', question.type + '-type']"
                :is="responseType(question.type)" 
                :response="getAnswer(question, response)"
                :is-multi="true"
                :question="question" />
        </div>
    </div>
</template>

<script>
import DatePartial from './DatePartial'
import ImageSelectPartial from './ImageSelectPartial'
import SelectPartial from './SelectPartial.vue'
import TextResponsePartial from './TextResponsePartial'
import ScrollerPartial from './ScrollerPartial.vue'
import UnitPartial from './UnitPartial.vue'
import responseMap from './map'
import isEmptyObj from '@/module/util/empty-object'


export default {   
    name: 'multi-question-partial',

    props: {
        question: {
			type: Object,
			required: true
		},
		response: {
			type: Array,
			required: true
		},
    },
    
    methods: {
        getAnswer(question, resArr) {
            const questionId = question.id
            const response = resArr.find((res) => res.id === questionId)
            if(response && !this.isEmptyAnswer(response)) {
                const answer = response.answer
                 if(question.type === 'text')
                    return { 0: answer[0].answer }
                if(question.type === 'select')
                    return answer.map((ansObj) => ansObj.value)
                if(question.type === 'scroller')
                    return Array.isArray(answer) && (answer.length === 1) ? { [answer[0].value] : question.label[answer[0].value] } : null
                return response.answer
            }
           
            return null
        },
        isEmptyAnswer(response) {
            const answer = response.answer
            if(answer && Array.isArray(answer) && answer.length === 0)
                return true
            if(answer && Array.isArray(answer) && answer.length === 1 && isEmptyObj(answer[0]))
                return true
            return false
        },
        responseType(type) {
            return responseMap[type]
        }
    },
    components: {
        DatePartial,
        ImageSelectPartial,
        TextResponsePartial,
        ScrollerPartial,
        UnitPartial,
        SelectPartial
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
